<div class="editing-strategy"><span class="icon-i-info"></span>{{ 'editModeBanner.label' | translate }}</div>
